// Constants for analytics formatters
// @flow
export const ANALYTICS_TYPES = {
    READINESS_SURVEY_ATHLETE: 'readiness-survey-athlete',
    READINESS_SURVEY_TEAM: 'readiness-survey-team',
    TRAINING_SUMMARY_ATHLETE: 'training-summary-athlete',
    TRAINING_SUMMARY_TEAM: 'training-summary-team',
    LIFT_HISTORY: 'lift-history',
    LIFT_ONE_REP_MAX: 'lift-one-rep-max',
    LIFT_ONE_REP_MAX_HISTORY: 'lift-one-rep-max-history',
    LIFT_PROGRESS: 'lift-progress',
    WORKING_MAX_HISTORY: 'working-max-history',
    COMPLIANCE: 'compliance',
    MARKETPLACE_ATTRIBUTIONS: 'marketplace-attributions'
};



// WEBPACK FOOTER //
// ./src/view/common/constants.js